export const MuiTabs = (palette) => {
    return {
        root: {
            '&.tiny': {
                minHeight: '22px',
                '& .MuiTabs-indicator': { height: '2px' },
            },
            '&.default': {
                minHeight: '40px',
                '& .MuiTabs-indicator': { height: '4px' },
            },
        },
        indicator: {
            backgroundColor: palette.semantic.colorPrimary,
            height: '4px',
        },
    };
};
